module.exports = {
	"ha": "bc",
	"id": 5.5,
	"report": {
		"ha": "BC",
		"group": "Health Authority",
		"period": "2017 Q3–2018 Q2",
		"lastYear": "2018",
		"lastQuarter": "2"
	},
	"globalOptions": {
		"lang": {
			"numericSymbols": null
		}
	},
	"instr": {
		"chart": {
			"plotBackgroundColor": "#e1e2e4",
			"alignTicks": false,
			"width": 950,
			"height": 530,
			"marginTop": 80,
			"marginLeft": 110,
			"style": {
				"fontFamily": "Lato",
				"color": "#2c3e50"
			},
			"type": "column"
		},
		"credits": {
			"enabled": false
		},
		"legend": {
			"enabled": false
		},
		"tooltip": {
			"valueDecimals": 1,
			"valueSuffix": " %"
		},
		"title": {
			"align": "left",
			"x": -10,
			"useHTML": true,
			"text": "<span style=\"display: table;\">                 <span style=\"display: table-cell; min-width: 110px;\">Figure 5.5</span>                 <span style=\"display: table-cell;\">Estimated Cascade of Care for BC by Age Category and MSM Status, Year Ending 2018 Q2 <sup style=\"font-size: 10px;\">9</sup></span>               </span>",
			"style": {
				"fontSize": "14px",
				"color": "#2c3e50"
			}
		},
		"plotOptions": {
			"series": {
				"marker": {
					"enabled": false
				},
				"dataLabels": {
					"allowOverlap": true,
					"useHTML": true,
					"style": {},
					"verticalAlign": "top"
				},
				"pointPadding": 0,
				"groupPadding": 0,
				"stacking": "normal",
				"colorByPoint": true
			},
			"column": {
				"colors": [
					"",
					"#043f61",
					"#0c4250",
					"#0d4440",
					"#09472e",
					"#0a4a23"
				]
			}
		},
		"xAxis": [
			{
				"lineWidth": 0,
				"tickWidth": 0,
				"labels": {
					"reserveSpace": false,
					"rotation": 270,
					"y": -100,
					"align": "left",
					"style": {
						"fontSize": "1.2em",
						"color": "white",
						"textOutline": "0.5px contrast"
					}
				},
				"categories": [
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					""
				]
			}
		],
		"yAxis": [
			{
				"height": "60%",
				"max": 100,
				"tickPosition": "inside",
				"lineColor": "#231f20",
				"lineWidth": 1,
				"tickColor": "#231f20",
				"tickInterval": 20,
				"minorTickPosition": "inside",
				"minorTickInterval": 10,
				"tickWidth": 1,
				"minorTickWidth": 1,
				"minorTickColor": "#231f20",
				"tickLength": 12,
				"minorTickLength": 8,
				"gridLineWidth": 0,
				"minorGridLineWidth": 0,
				"offset": 0,
				"title": {
					"text": "% of Diagnosed",
					"margin": -10,
					"x": -30
				},
				"labels": {
					"format": "{value}%"
				},
				"plotLines": [
					{
						"value": 0,
						"color": "black",
						"dashStyle": "solid",
						"width": 1,
						"zIndex": 100
					}
				]
			},
			{
				"top": "60%",
				"height": "40%",
				"tickPosition": "inside",
				"lineColor": "#9e1c20",
				"lineWidth": 1,
				"tickColor": "#9e1c20",
				"tickInterval": 20,
				"minorTickPosition": "inside",
				"minorTickInterval": 10,
				"tickWidth": 1,
				"minorTickWidth": 1,
				"minorTickColor": "#9e1c20",
				"tickLength": 12,
				"minorTickLength": 8,
				"gridLineWidth": 0,
				"minorGridLineWidth": 0,
				"offset": 0,
				"max": 0,
				"min": -60,
				"title": {
					"text": "% Loss from<br>Previous Stage",
					"margin": -10,
					"style": {
						"color": "#9e1c20"
					},
					"x": -30
				},
				"labels": {
					"format": "{value}%",
					"style": {
						"color": "#9e1c20"
					},
					"zIndex": 1
				}
			}
		],
		"series": [
			{
				"name": "% of Diagnosed",
				"yAxis": 0,
				"data": [
					{
						"y": null
					},
					{
						"y": 90.625,
						"dataLabels": {
							"enabled": false,
							"format": "145"
						},
						"color": "#043f61"
					},
					{
						"y": 82.5,
						"dataLabels": {
							"enabled": false,
							"format": "132"
						},
						"color": "#0c4250"
					},
					{
						"y": 77.5,
						"dataLabels": {
							"enabled": false,
							"format": "124"
						},
						"color": "#0d4440"
					},
					{
						"y": 69.375,
						"dataLabels": {
							"enabled": false,
							"format": "111"
						},
						"color": "#09472e"
					},
					{
						"y": 65,
						"dataLabels": {
							"enabled": false,
							"format": "104"
						},
						"color": "#0a4a23"
					},
					{
						"y": null
					},
					{
						"y": 97.37373737373738,
						"dataLabels": {
							"enabled": false,
							"format": "482"
						},
						"color": "#043f61"
					},
					{
						"y": 84.04040404040404,
						"dataLabels": {
							"enabled": false,
							"format": "416"
						},
						"color": "#0c4250"
					},
					{
						"y": 79.39393939393939,
						"dataLabels": {
							"enabled": false,
							"format": "393"
						},
						"color": "#0d4440"
					},
					{
						"y": 72.72727272727273,
						"dataLabels": {
							"enabled": false,
							"format": "360"
						},
						"color": "#09472e"
					},
					{
						"y": 62.62626262626263,
						"dataLabels": {
							"enabled": false,
							"format": "310"
						},
						"color": "#0a4a23"
					},
					{
						"y": null
					},
					{
						"y": 97.3293768545994,
						"dataLabels": {
							"enabled": false,
							"format": "656"
						},
						"color": "#043f61"
					},
					{
						"y": 86.35014836795251,
						"dataLabels": {
							"enabled": false,
							"format": "582"
						},
						"color": "#0c4250"
					},
					{
						"y": 80.41543026706232,
						"dataLabels": {
							"enabled": false,
							"format": "542"
						},
						"color": "#0d4440"
					},
					{
						"y": 74.77744807121661,
						"dataLabels": {
							"enabled": false,
							"format": "504"
						},
						"color": "#09472e"
					},
					{
						"y": 66.32047477744807,
						"dataLabels": {
							"enabled": false,
							"format": "447"
						},
						"color": "#0a4a23"
					},
					{
						"y": null
					},
					{
						"y": 98.80495091762698,
						"dataLabels": {
							"enabled": false,
							"format": "2315"
						},
						"color": "#043f61"
					},
					{
						"y": 90.22620571916346,
						"dataLabels": {
							"enabled": false,
							"format": "2114"
						},
						"color": "#0c4250"
					},
					{
						"y": 86.00085360648741,
						"dataLabels": {
							"enabled": false,
							"format": "2015"
						},
						"color": "#0d4440"
					},
					{
						"y": 83.05591122492531,
						"dataLabels": {
							"enabled": false,
							"format": "1946"
						},
						"color": "#09472e"
					},
					{
						"y": 73.66623986342297,
						"dataLabels": {
							"enabled": false,
							"format": "1726"
						},
						"color": "#0a4a23"
					},
					{
						"y": null
					},
					{
						"y": null
					},
					{
						"y": 93.54838709677419,
						"dataLabels": {
							"enabled": false,
							"format": "58"
						},
						"color": "#043f61"
					},
					{
						"y": 80.64516129032258,
						"dataLabels": {
							"enabled": false,
							"format": "50"
						},
						"color": "#0c4250"
					},
					{
						"y": 72.58064516129032,
						"dataLabels": {
							"enabled": false,
							"format": "45"
						},
						"color": "#0d4440"
					},
					{
						"y": 54.83870967741935,
						"dataLabels": {
							"enabled": false,
							"format": "34"
						},
						"color": "#09472e"
					},
					{
						"y": 41.935483870967744,
						"dataLabels": {
							"enabled": false,
							"format": "26"
						},
						"color": "#0a4a23"
					},
					{
						"y": null
					},
					{
						"y": 97.01492537313433,
						"dataLabels": {
							"enabled": false,
							"format": "325"
						},
						"color": "#043f61"
					},
					{
						"y": 88.05970149253731,
						"dataLabels": {
							"enabled": false,
							"format": "295"
						},
						"color": "#0c4250"
					},
					{
						"y": 80,
						"dataLabels": {
							"enabled": false,
							"format": "268"
						},
						"color": "#0d4440"
					},
					{
						"y": 65.97014925373135,
						"dataLabels": {
							"enabled": false,
							"format": "221"
						},
						"color": "#09472e"
					},
					{
						"y": 47.76119402985074,
						"dataLabels": {
							"enabled": false,
							"format": "160"
						},
						"color": "#0a4a23"
					},
					{
						"y": null
					},
					{
						"y": 97.82330345710626,
						"dataLabels": {
							"enabled": false,
							"format": "764"
						},
						"color": "#043f61"
					},
					{
						"y": 86.68373879641486,
						"dataLabels": {
							"enabled": false,
							"format": "677"
						},
						"color": "#0c4250"
					},
					{
						"y": 80.92189500640204,
						"dataLabels": {
							"enabled": false,
							"format": "632"
						},
						"color": "#0d4440"
					},
					{
						"y": 71.44686299615877,
						"dataLabels": {
							"enabled": false,
							"format": "558"
						},
						"color": "#09472e"
					},
					{
						"y": 50.70422535211267,
						"dataLabels": {
							"enabled": false,
							"format": "396"
						},
						"color": "#0a4a23"
					},
					{
						"y": null
					},
					{
						"y": 97.9240806642942,
						"dataLabels": {
							"enabled": false,
							"format": "1651"
						},
						"color": "#043f61"
					},
					{
						"y": 88.37485172004746,
						"dataLabels": {
							"enabled": false,
							"format": "1490"
						},
						"color": "#0c4250"
					},
					{
						"y": 83.62989323843416,
						"dataLabels": {
							"enabled": false,
							"format": "1410"
						},
						"color": "#0d4440"
					},
					{
						"y": 77.58007117437722,
						"dataLabels": {
							"enabled": false,
							"format": "1308"
						},
						"color": "#09472e"
					},
					{
						"y": 61.62514827995255,
						"dataLabels": {
							"enabled": false,
							"format": "1039"
						},
						"color": "#0a4a23"
					},
					{
						"y": null
					},
					{
						"y": null
					},
					{
						"y": 49.828178694158076,
						"dataLabels": {
							"enabled": false,
							"format": "145"
						},
						"color": "#043f61"
					},
					{
						"y": 38.83161512027492,
						"dataLabels": {
							"enabled": false,
							"format": "113"
						},
						"color": "#0c4250"
					},
					{
						"y": 36.08247422680412,
						"dataLabels": {
							"enabled": false,
							"format": "105"
						},
						"color": "#0d4440"
					},
					{
						"y": 29.896907216494846,
						"dataLabels": {
							"enabled": false,
							"format": "87"
						},
						"color": "#09472e"
					},
					{
						"y": 22.336769759450174,
						"dataLabels": {
							"enabled": false,
							"format": "65"
						},
						"color": "#0a4a23"
					},
					{
						"y": null
					},
					{
						"y": 85.6581532416503,
						"dataLabels": {
							"enabled": false,
							"format": "436"
						},
						"color": "#043f61"
					},
					{
						"y": 63.85068762278978,
						"dataLabels": {
							"enabled": false,
							"format": "325"
						},
						"color": "#0c4250"
					},
					{
						"y": 58.153241650294696,
						"dataLabels": {
							"enabled": false,
							"format": "296"
						},
						"color": "#0d4440"
					},
					{
						"y": 52.06286836935167,
						"dataLabels": {
							"enabled": false,
							"format": "265"
						},
						"color": "#09472e"
					},
					{
						"y": 45.579567779960705,
						"dataLabels": {
							"enabled": false,
							"format": "232"
						},
						"color": "#0a4a23"
					},
					{
						"y": null
					},
					{
						"y": 86.19201725997843,
						"dataLabels": {
							"enabled": false,
							"format": "799"
						},
						"color": "#043f61"
					},
					{
						"y": 58.57605177993528,
						"dataLabels": {
							"enabled": false,
							"format": "543"
						},
						"color": "#0c4250"
					},
					{
						"y": 54.36893203883495,
						"dataLabels": {
							"enabled": false,
							"format": "504"
						},
						"color": "#0d4440"
					},
					{
						"y": 49.94606256742179,
						"dataLabels": {
							"enabled": false,
							"format": "463"
						},
						"color": "#09472e"
					},
					{
						"y": 42.07119741100323,
						"dataLabels": {
							"enabled": false,
							"format": "390"
						},
						"color": "#0a4a23"
					},
					{
						"y": null
					},
					{
						"y": 84.72412220702235,
						"dataLabels": {
							"enabled": false,
							"format": "1858"
						},
						"color": "#043f61"
					},
					{
						"y": 55.357957136342904,
						"dataLabels": {
							"enabled": false,
							"format": "1214"
						},
						"color": "#0c4250"
					},
					{
						"y": 51.52758777929777,
						"dataLabels": {
							"enabled": false,
							"format": "1130"
						},
						"color": "#0d4440"
					},
					{
						"y": 48.97400820793434,
						"dataLabels": {
							"enabled": false,
							"format": "1074"
						},
						"color": "#09472e"
					},
					{
						"y": 41.99726402188782,
						"dataLabels": {
							"enabled": false,
							"format": "921"
						},
						"color": "#0a4a23"
					},
					{
						"y": null
					}
				],
				"table": {
					"visible": false
				}
			},
			{
				"name": "% Loss from Previous Stage",
				"yAxis": 1,
				"data": [
					{
						"y": null
					},
					{
						"y": -9.375,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -8.965517241379306,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -6.060606060606055,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -10.483870967741938,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -6.3063063063063085,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": null
					},
					{
						"y": -2.626262626262621,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -13.692946058091282,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -5.528846153846157,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -8.3969465648855,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -13.888888888888884,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": null
					},
					{
						"y": -2.670623145400597,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -11.280487804878048,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -6.872852233676974,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -7.011070110701112,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -11.309523809523814,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": null
					},
					{
						"y": -1.195049082373023,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -8.68250539956803,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -4.683065279091769,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -3.4243176178660018,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -11.305241521068854,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": null
					},
					{
						"y": null
					},
					{
						"y": -6.451612903225811,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -13.793103448275868,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -9.999999999999998,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -24.444444444444446,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -23.529411764705888,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": null
					},
					{
						"y": -2.985074626865669,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -9.230769230769232,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -9.152542372881356,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -17.537313432835823,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -27.601809954751133,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": null
					},
					{
						"y": -2.17669654289373,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -11.387434554973819,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -6.646971935007384,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -11.708860759493668,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -29.032258064516125,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": null
					},
					{
						"y": -2.0759193357058114,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -9.751665657177465,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -5.369127516778526,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -7.234042553191489,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -20.56574923547401,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": null
					},
					{
						"y": null
					},
					{
						"y": -50.171821305841924,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -22.06896551724138,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -7.079646017699115,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -17.14285714285714,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -25.287356321839084,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": null
					},
					{
						"y": -14.341846758349707,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -25.458715596330272,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -8.923076923076923,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -10.472972972972972,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -12.452830188679243,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": null
					},
					{
						"y": -13.807982740021574,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -32.04005006257822,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -7.182320441988955,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -8.13492063492064,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -15.766738660907132,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": null
					},
					{
						"y": -15.275877792977655,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -34.660925726587735,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -6.919275123558489,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -4.9557522123893865,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -14.245810055865926,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": null
					}
				],
				"table": {
					"visible": false
				}
			}
		],
		"groups": [
			{
				"x": 12,
				"y": 40,
				"text": "MSM"
			},
			{
				"x": 3,
				"text": "<30<br>n=160"
			},
			{
				"x": 9,
				"text": "30-39<br>n=495"
			},
			{
				"x": 15,
				"text": "40-49<br>n=674"
			},
			{
				"x": 21,
				"text": ">=50<br>n=2343"
			},
			{
				"x": 37,
				"y": 40,
				"text": "Non-MSM"
			},
			{
				"x": 28,
				"text": "<30<br>n=62"
			},
			{
				"x": 34,
				"text": "30-39<br>n=335"
			},
			{
				"x": 40,
				"text": "40-49<br>n=781"
			},
			{
				"x": 46,
				"text": ">=50<br>n=1686"
			},
			{
				"x": 62,
				"y": 40,
				"text": "Unknown"
			},
			{
				"x": 53,
				"text": "<30<br>n=291"
			},
			{
				"x": 59,
				"text": "30-39<br>n=509"
			},
			{
				"x": 65,
				"text": "40-49<br>n=927"
			},
			{
				"x": 71,
				"text": ">=50<br>n=2193"
			}
		],
		"dataTable": {
			"MSM:<30": [
				160,
				145,
				132,
				124,
				111,
				104
			],
			"MSM:30-39": [
				495,
				482,
				416,
				393,
				360,
				310
			],
			"MSM:40-49": [
				674,
				656,
				582,
				542,
				504,
				447
			],
			"MSM:>=50": [
				2343,
				2315,
				2114,
				2015,
				1946,
				1726
			],
			"Non-MSM:<30": [
				62,
				58,
				50,
				45,
				34,
				26
			],
			"Non-MSM:30-39": [
				335,
				325,
				295,
				268,
				221,
				160
			],
			"Non-MSM:40-49": [
				781,
				764,
				677,
				632,
				558,
				396
			],
			"Non-MSM:>=50": [
				1686,
				1651,
				1490,
				1410,
				1308,
				1039
			],
			"Unknown:<30": [
				291,
				145,
				113,
				105,
				87,
				65
			],
			"Unknown:30-39": [
				509,
				436,
				325,
				296,
				265,
				232
			],
			"Unknown:40-49": [
				927,
				799,
				543,
				504,
				463,
				390
			],
			"Unknown:>=50": [
				2193,
				1858,
				1214,
				1130,
				1074,
				921
			]
		}
	},
	"callback": "C:\\Users\\Rafael\\Projects\\cfenet.ubc.ca-qmr\\src\\cli/callback.js",
	"outfile": "./temp/png/figure_bc_5_5.png"
};


//////////////////
// WEBPACK FOOTER
// ./temp/json/figure_bc_5_5.json
// module id = 169
// module chunks = 0